import React from 'react';
import { Button, Card } from 'antd';


import SortableComponent from './sortable-component';


class SortBannerCard extends React.Component {
    render() {

        const { banners, loading } = this.state;

        return(
            <Card 
                className="sortable-card-container"
                title='Drag and drop to arrange banner sequence'
                extra={
                    <Button 
                        onClick={this.submitBannerSequence}
                        loading={loading}
                        disabled={!this.props.editSequence}
                        type={this.props.editSequence? 'primary' : null}
                        size="small"
                    >
                        Update
                    </Button>
                }

            >
                <SortableComponent 
                    banners={banners}
                    onSortEnd={this.onSortEnd}
                    />
            </Card>
        )
    }

    constructor(props){
        super(props);
        this.state = {
            visible: false,
            banners: [],
            loading: false
        }
    }

    componentWillMount(){
        const activeBanners = this.filterActiveBanners(this.props.banners);

        this.setState({
            visible: this.props.visible,
            banners: activeBanners
        })

        // console.log("EDIT PROPS", this.props)
    }

    componentWillReceiveProps(newProps) {
        // console.log("new props")
        if(newProps.banners.length !== this.state.banners.length) {
            const activeBanners = this.filterActiveBanners(newProps.banners);

            this.setState({
                banners: activeBanners
            })
        }
    }

    closeSequenceModal = () => {
        this.props.closeSequenceModal();
    }

    filterActiveBanners = (banners) => {
        if(banners === null || banners.length<1) {
            return null;
        }

        const activeBanners = banners.filter( _banner => {
            return _banner.active;
        })

        return activeBanners;
    }

    submitBannerSequence = () => {
        // console.log("new banners to be submitted = " , this.state.banners)
        this.setState({
            loading: true
        })
        setTimeout(() => {
            this.props.submitBannerSequence(this.state.banners)
            this.setState({ loading: false})
        }, 800)
    }
    
    onSortEnd = ( newBanners ) => {
        this.setState({
            banners: newBanners
        })
        this.props.edittingSequence();
    }
}

export default SortBannerCard;


// WEBPACK FOOTER //
// ./src/components/banners/sort-banner-card/index.js